/**
Author - Babajan Patan
Git - https://www.linkedin.com/in/babajan-patan
**/

import React from "react";
import SafeLink from "components/commons/SafeLink";

import Head from "next/head";

import styled from "styled-components";
import GlobalStyle from "static/next/css/PartnerGlobalStyle";

import {WealthyEnv} from "helpers";

import {NewFooter} from "components";
import {SegmentAnalytics} from "components";

import {
  LogoWrapper,
  LogoImage
} from "components/StaticPages/Common";

const spreadSheetLink = "https://docs.google.com/spreadsheets/d/1DMmNJY4jfHJuIDHxCJAqnXowrrasAZkfrLxxMyNESws/edit?gid=0#gid=0";

const DownloadForms = () => {
  return (
    <Wrapper>

      <Head>
        <title>List of Authorised Persons</title>
        <meta content="Register as a Wealthy Partner and sell start your wealth management career. Earn 2x more. Access 800+ financial products on a single platform." name="description" />
        <meta content="Become Wealthy Partner | Sell Financial Products & Earn - Wealthy" name="title" />
        <meta content="Wealth Management Jobs, Relationship Management Jobs, Private Banker Jobs, Portfolio Manager Jobs, Investment Manager Jobs" name="keywords" />
        <meta content="https://i.wlycdn.com/wealthy-home-page/partner-page-new-meta-image.webp" property="og:image" />
        <link href={`${WealthyEnv.URL}/compliance/list-of-authorised-persons`} rel="canonical" />
        <link href="https://i.wlycdn.com/wealthy-home-page/new-fav-icon.png" rel="icon" />
        <link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.2.0/css/font-awesome.min.css" rel="stylesheet" />
        <link as="style" href="/static/next/css/header-footer.css" rel="preload" />
        <link href="/static/next/css/header-footer.css" rel="stylesheet" />
        <link href="/static/next/css/ReactToastify.min.css" rel="stylesheet" />
        <link as="style" href="static/next/css/index.css" id="index-style" rel="preload" />
      </Head>
      <SegmentAnalytics />
      <GlobalStyle />

      <LogoWrapper>
        <SafeLink href={WealthyEnv.URL}>
          <LogoImage
            alt="Wealthy"
            src={`${WealthyEnv.HOMEPAGE_CDN_URL}/wealthy-new-purple-logo.svg`}
          />
        </SafeLink>
      </LogoWrapper>

      <ContentWrapper>
        <Title>List Of Authorised Persons</Title>
        <DownloadListContainer>
          <DownloadItem>
            <div className="download-container">
              <SafeLink
                download
                className="download-link"
                href={spreadSheetLink}
                rel="noopener noreferrer"
                target="_blank"
              >
                <span className="download-text">Click Here to View</span>
              </SafeLink>
            </div>
          </DownloadItem>
        </DownloadListContainer>
      </ContentWrapper>
      <NewFooter />
    </Wrapper>
  );
};

const Wrapper = styled.div``;

const ContentWrapper = styled.div`
  padding: 5rem 0 20rem 0;
`;

const Title = styled.h1`
  font-family: MavenPro;
  font-size: 4rem;
  color: #222;
  text-align: center;
  margin: 2rem auto;

  @media (max-width:768px){
    font-size: 2.5rem;
  }
`;

const DownloadListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: start;
`;

const FormWrapper = styled.div`
  padding-left: 15%;
`;

const DownloadItem = styled.div`
  flex-basis: calc(50% - 1rem);
  margin: 0;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    flex-basis: 100%;
  }

  .download-container {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 100%;

    .download-text {
      margin-top: 0.5rem;
      color: #666;
      padding: 1rem;

      :hover {
        color: rgb(103, 37, 244);
      }
    }

    .download-link {
      font-size: 1.8rem;

      :hover {
        color: rgb(103, 37, 244);
      }
    }
  }`;


export default DownloadForms;
